import { useCallback } from 'react';

import { VOID_FUNCTION } from 'constants/index';
import { getChangeEvent } from 'components/modules/Insurance/Insurance.helpers';

import { ISSUER_HANDLER_KEYS } from '../../Policyholder.constants';

export const useIssuerInputPresenter = ({
  name: nameProp,
  onChange: onChangeProp = VOID_FUNCTION,
  type = 'code',
}) => {
  const onChange = useCallback(
    (event) => {
      const { value } = getChangeEvent(event);

      if (type === 'code' && typeof value === 'string') {
        return;
      }

      let code;
      let name = type === 'name' ? value : undefined;

      if (typeof value !== 'string') {
        const { data } = value;
        const { code: daDataIssuerCode, name: daDataIssuerName } = data ?? {};

        code = daDataIssuerCode;
        name = daDataIssuerName;
      }

      const payload = { [ISSUER_HANDLER_KEYS.CODE]: code, [ISSUER_HANDLER_KEYS.NAME]: name };

      onChangeProp(nameProp ? { [nameProp]: payload } : payload);
    },
    [type, onChangeProp, nameProp]
  );

  return { onChange };
};
